import { render } from "./IconSpo.vue?vue&type=template&id=7e1347a2"
import script from "./IconSpo.vue?vue&type=script&lang=js"
export * from "./IconSpo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__